// neo_cogym — 디바이스 전송 추상화
// 코드위즈(ESP32)와의 바이트 스트림을 추상화한다.
// 구현체: WebSerialTransport(USB 직결) / RelayTransport(WiFi 릴레이 WSS).
// REPL 클라이언트(replClient.ts)는 이 인터페이스에만 의존 → 전송 방식과 무관하게 동작.

export interface Transport {
  /** 연결을 연다. (WebSerial: 포트 선택+open+부트시퀀스 / Relay: WSS 연결) */
  open(): Promise<void>;
  /** 바이트 전송 */
  write(data: Uint8Array): Promise<void>;
  /** 수신 콜백 등록. 해제 함수를 반환 */
  onData(cb: (chunk: Uint8Array) => void): () => void;
  /** 연결 종료 */
  close(): Promise<void>;
  readonly isOpen: boolean;
  readonly kind: TransportKind;
}

export type TransportKind = "webserial" | "relay" | "webbluetooth";

/** 코드위즈 보레이트(T1 분석: 접속/플래시/REPL) */
export const BAUD = {
  connect: 119500,
  flash: 2000000,
  repl: 115200,
} as const;

/** 텍스트 인코딩 헬퍼 */
export const enc = new TextEncoder();
export const dec = new TextDecoder();

export function toBytes(s: string): Uint8Array {
  return enc.encode(s);
}
